<script setup lang="ts">
import { computed } from 'vue'
import { useMatchingSignals } from '@/composables/useMatchingSignals'
import MatchingAccordionPanel from '@/components/dashboard/matching/MatchingAccordionPanel.vue'
import MatchingEmailsSection from '@/components/dashboard/matching/MatchingEmailsSection.vue'
import MatchingCardsSection from '@/components/dashboard/matching/MatchingCardsSection.vue'
import PersonalDetailsBlock from '@/components/dashboard/shared/PersonalDetailsBlock.vue'

const {
  isAuthorised,
  isStatusKnown,
  resolvedIdentitySummary,
  emailsSummary,
  cardsSummary,
} = useMatchingSignals()

const showAuthNote = computed(() => isStatusKnown.value && !isAuthorised.value)
</script>

<template>
  <section class="sa-acct-section sa-gift-aid-matching" aria-labelledby="gift-aid-matching-heading">
    <h2 id="gift-aid-matching-heading">{{ $t('Dashboard.Status.Matching.Heading') }}</h2>

    <p class="sa-gift-aid-matching__lead">{{ $t('Dashboard.Status.Matching.Lead') }}</p>

    <p v-if="showAuthNote" class="sa-gift-aid-matching__auth-note" role="note">
      {{ $t('Dashboard.Status.Matching.AuthNote') }}
    </p>

    <div class="sa-matching-accordion">
      <MatchingAccordionPanel
        panel-id="matching-identity-panel"
        icon="settings"
        :title="$t('Dashboard.Status.Personal.Heading')"
        :summary="resolvedIdentitySummary"
      >
        <p class="sa-matching-accordion-panel__lead">
          {{ $t('Dashboard.Status.Personal.Lead') }}
        </p>
        <PersonalDetailsBlock context="matching" />
      </MatchingAccordionPanel>

      <MatchingAccordionPanel
        panel-id="matching-emails-panel"
        icon="email"
        :title="$t('Dashboard.Status.Emails.Heading')"
        :summary="emailsSummary"
      >
        <MatchingEmailsSection embedded />
      </MatchingAccordionPanel>

      <MatchingAccordionPanel
        panel-id="matching-cards-panel"
        icon="card"
        :title="$t('Dashboard.Status.Cards.Heading')"
        :summary="cardsSummary"
      >
        <MatchingCardsSection embedded />
      </MatchingAccordionPanel>
    </div>
  </section>
</template>
